import { ColumnType } from 'antd/es/table';

export interface CustomColumn<T> extends ColumnType<T> {
    dataIndex?: keyof T & string;
    key?: keyof T & string;
}

export interface BaseMetaDocument {
    id: number;
    fileUid: string;
    fileName: string;
    contentType: string;
    fileSize: number;
    fileHash: string;
    targetClass: string;
    targetId: number;
    documentCategory: string;
    deleted: boolean;
    version: number;
    compressed: boolean;
}

export interface BaseTable<T> {
    content: T[];
    empty: boolean;
    first: boolean;
    last: boolean;
    number: number;
    numberOfElements: number;
    pageable: TablePageable;
    size: number;
    sort: TableSort;
    totalElements: number;
    totalPages: number;
}

export interface TablePageable {
    offset: number;
    pageNumber: number;
    pageSize: number;
    paged: boolean;
    sort: TableSort;
    size: number;
}

export interface TableSort {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
}

export enum KnowledgeBaseLanguage {
    ru = 'ru',
    kz = 'kz',
    en = 'en',
}

export enum Language {
    qq = 'en_150',
    ru = 'ru',
    kz = 'kk_KZ',
    en = 'en_US',
}

export enum CapitalizedLang {
    Ru = 'Ru',
    Kz = 'Kz',
    En = 'En',
    Qq = 'Qq',
}

export interface WrapperProps {
    onShow: any;
    config: any;
    language: Language;
    react4xpId: string;
    locale: string;
    token: null | string;
    translations: Record<string, string>;
    commonTranslations: Record<string, string>;
}

export type ILangValue = 'en' | 'kk' | 'ru' | 'qq' | 'EN' | 'KK' | 'RU' | 'QQ' | string;

export interface BaseProps {
    config: Record<string, any>;
    translations: Record<string, string>;
    language: string;
    serviceUrl: string;
}
